import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import close from '../../static/images/close.svg';
import { FormElems, AlertModal } from '../../components/';
import './MerchantReportModal.scss';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css'
import orangeinfo from "../../static/images/orangeinfo.png";
import grayinfo from '../../static/images/grayinfo.png';
import { validateReports } from './validator';

const MerchantReportModal = ({
  setModalOpen,
  selectedReportType,
  reportParameters,
  setReportParameters,
  isMRViewMode,
  handleCombinedReports,
  loading,
}) => {
  const isMRViewModeValue = isMRViewMode || false;
  const [initialValue , setInitialValue] = useState(null);

  useEffect(() =>{
    if(!initialValue && !!reportParameters){
      setInitialValue(reportParameters);
    }
  }, [initialValue, reportParameters])

  const handleClose = () =>{
    setReportParameters(initialValue);
    setModalOpen(false);
  }

  const handleOnDragEnd = (result) => {
    if (isMRViewModeValue || !result.destination || result.source.index === result.destination.index) return;

    const updatedConfiguration = [...reportParameters[selectedReportType][0].configuration];

    const [reorderedItem] = updatedConfiguration.splice(result.source.index, 1);
    updatedConfiguration.splice(result.destination.index, 0, reorderedItem);

    const reorderedWithSeq = updatedConfiguration.map((item, index) => {
      return item.isEnable ? { ...item, seq: index } : { ...item, seq: -1 };
    });

    setReportParameters((prev) => ({
      ...prev,
      [selectedReportType]: [
        {
          ...prev[selectedReportType][0],
          configuration: reorderedWithSeq,
        },
      ],
    }));
  };


  // Toggle enable/disable for a parameter
  const toggleEnable = (id) => {
    if (isMRViewModeValue) return;

    const updated = reportParameters[selectedReportType][0].configuration.map((char) => {
      if (char.param === id) {
        return {
          ...char,
          isEnable: !char.isEnable,
          seq: !char.isEnable ? -1 : char.seq,
        };
      }
      return char;
    });

    const enabledItems = updated.filter(char => char.isEnable);
    const reordered = enabledItems.map((char, index) => ({ ...char, seq: index }));

    const finalUpdated = updated.map(char =>
      char.isEnable ? reordered.find(r => r.param === char.param) : { ...char, seq: -1 }
    );

    setReportParameters(prev => ({
      ...prev,
      [selectedReportType]: [{ ...prev[selectedReportType][0], configuration: finalUpdated }]
    }));
  };

  const [error, setError] = useState("");

  const handleContinue = (e) => {
    e.preventDefault();

    const { isValid, message } = validateReports(reportParameters[selectedReportType][0]["configuration"], selectedReportType);

    if (!isValid) {
      setError(message);
      return;
    }

    setError("");
    handleCombinedReports(reportParameters);
  };


  if (loading) return <div>Loading...</div>;

  return (
    <div className="modal-overlay two">

      <AlertModal
        headerText='Alert'
        modalIsOpen={!!error}
        primaryButtonText="OK"
        showActions={true}
        onSuccessModal={() => setError("")}
        message={error}
      />

      <div className="modal-content two">
        <div className='model-header-container'>
          <h1 className="heading">{selectedReportType} Report Headers</h1>
          {!isMRViewModeValue && (
            <h5 className='heading sm'>You can edit the name of the headers and can rearrange them using drop and drop</h5>
          )}
          <img
            src={close}
            alt="Close"
            className="close"
            onClick={handleClose}
          />
        </div>

        {/* Scrollable content */}
        <div className="scrollable-content">
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="characters">
              {(provided) => (
                <ul className="characters" {...provided.droppableProps} ref={provided.innerRef}>
                  {reportParameters[selectedReportType][0].configuration.map(({ param, name, isEnable, desc }, index) => (
                    <Draggable key={index + ""} draggableId={index + ""} index={index} isDragDisabled={isMRViewModeValue}>
                      {(provided, snapshot) => (
                        <li
                          className={`draggable ${snapshot.isDragging ? 'dragging' : ''} ${isMRViewModeValue ? 'disabled' : ''}`}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <div
                            className={`custom-checkbox ${isEnable ? 'checked' : ''} ${isMRViewModeValue ? 'disabled' : ''}`}
                            onClick={() => toggleEnable(param)}
                          ></div>
                          <div className='headerInfo'>
                            <p>{index + 1}.</p>
                            <input
                              type="text"
                              value={name}
                              onChange={(e) => {
                                const newName = e.target.value;
                                setReportParameters(prev => ({
                                  ...prev,
                                  [selectedReportType]: [{
                                    ...prev[selectedReportType][0],
                                    configuration: prev[selectedReportType][0].configuration.map(item =>
                                      item.param === param ? { ...item, name: newName } : item
                                    )
                                  }]
                                }));
                              }}
                              disabled={isMRViewModeValue} // Disable in view mode
                            />
                          </div>
                          <div className='info'>
                            <Tooltip
                              placement="left"
                              overlay={
                                <div className={`custom-tooltip ${isMRViewModeValue ? 'tooltip-gray' : !isEnable ? 'tooltip-black' : ''}`}>
                                  {desc}
                                </div>
                              }>

                              <img src={isMRViewModeValue ? grayinfo : (isEnable ? orangeinfo : grayinfo)}
                                alt={`${name} info`} />
                            </Tooltip>
                          </div>
                        </li>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        </div>

        {/* Static Continue button */}
        {!isMRViewModeValue && (
          <div className="continue-btn-container">
            <FormElems.Button
              id="submit-btn"
              buttonType="primary"
              text="Continue"
              handleClick={handleContinue}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MerchantReportModal;
